<template>
  <a target="_blank" :href="url" class="icon is-large">
    <fa :icon="['fab', 'twitter']" size="2x" />
  </a>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      message: 'socialMessage',
    }),
    path() {
      return window.location.href;
    },
    url() {
      return `https://twitter.com/home?status=${this.path} ${this.message}`;
    }
  },
};
</script>
